<template lang="pug">
  #ContactsIndex
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 櫃點報表

    .container-width
      b-form-group.mx-3.mt-3.mb-1.text-gray
        b-form-select.border-0(
          id="card_type",
          required,
          v-model="searchInput.store_id",
          style="padding-right:3rem; border-radius: 20px;background-color: #eee;"
          @change='searchHandler()'
        )
          template(
            v-slot:first
          )
            b-form-select-option(
              :value="null",
              disabled
            ) 請選擇櫃點
          b-form-select-option(
            v-for="(store,index) in personnelStore",
            :key="`${store.id}_${store.id}`",
            :value="store.id"
          ) {{ store.title }}
        b-form-group.mt-3.mb-3.text-gray(
          label="日期區間"
        )
          .d-flex.align-items-center
            b-input(
              v-model="searchInput.start_date"
              type="date",
              placeholder="開始區間",
              style="flex: 2!important;border-radius: 20px;background-color: #eee;width: calc(100%/3);"
            )
            p.mb-0.text-center(
              style="flex-grow: 0.5!important;"
            ) -
            b-input(
              v-model="searchInput.end_date"
              type="date",
              placeholder="結束區間",
              style="flex: 2!important;border-radius: 20px;background-color: #eee;width: calc(100%/3);"
            )
      .row.no-gutters.mx-3
        .col-6.pr-2
          button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
            type="button",
            @click="resetHandler();",
            style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.15rem 0.15rem 0 #00000033;"
          ) 重置
        .col-6.pl-2
          button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
            type="button",
            @click="searchHandler()",
            style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.15rem 0.15rem 0 #00000033;"
          ) 搜尋
      .p-3.overflow-auto.text-center(
        :class="{ 'mr-3': reservationReports.length > 0 }",
        style="word-break: keep-all;"
      )
        table.table.table-bordered.table-striped
          thead.bg-black.text-white
            tr
              th(scope='col') 櫃點
              th(scope='col') BA
              th(scope='col') 綁定人數
              th(scope='col') 預約人數
              th(scope='col') 服務次數
          tbody(
            v-if="reservationReports.length > 0"
          )
            tr(
              v-for="(report, index) in reservationReports",
              style="white-space: nowrap;"
            )
              th(scope='row') {{ report.store_name }}
              th(scope='row') {{ report.preferred_name }}
              th(scope='row') {{ report.member_count }}
              th(scope='row') {{ report.reservation_count }}
              th(scope='row') {{ report.service_count }}
          tbody(
            v-else
          )
            tr
              td.text-center(
                colspan="9487"
              ) 暫無報表資料
</template>

<script>
import { mapState } from 'vuex';

const moment = require('moment');

export default {
  name: 'ReportIndex',
  data() {
    return {
      searchInput: {
        store_id: null,
        start_date: null,
        end_date: null,
      }
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    // 取得個人資料
    vm.$store.dispatch('sic_reports/getReservationReportHandler')
      .then(() => {
        vm.$swal.close();
        vm.$store.commit('toggleLoading', false);
      });
  },
  computed: {
    ...mapState({
      reservationReports: (state) => state.sic_reports.reservationReports,
      personnelStore: (state) => state.sic_stores_manager.personnelStoreData
    })
  },
  methods: {
    // 搜尋
    searchHandler() {
      const vm = this;
      if(vm.searchInput.store_id == null) {
        vm.$swal.fire({
          icon: 'error',
          title: '請選擇櫃點'
        });
        return;
      }
      if ((vm.searchInput.start_date && !vm.searchInput.end_date) || (!vm.searchInput.start_date && vm.searchInput.end_date)) {
        vm.$swal.fire({
          icon: 'error',
          title: '日期區間尚未選擇完全'
        });
      } else {

        if (vm.searchInput.start_date && vm.searchInput.end_date) {
          const startDateFormat = moment(vm.searchInput.start_date);
          const endDateFormat = moment(vm.searchInput.end_date);
          if (endDateFormat.isBefore(startDateFormat)) {
            vm.$swal.fire({
              icon: 'error',
              title: '日期區間結束時間不可小於開始時間'
            });
            return;
          }
        }
        vm.infiniteHandler();
      }
    },
    // 重置
    resetHandler() {
      const vm = this;
      vm.$store.commit('sic_reports/resetHandler');
      vm.searchInput = {
        store_id: null,
        start_date: null,
        end_date: null
      };
      vm.infiniteHandler();
    },
    infiniteHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 取得預約服務選項
      vm.$store.dispatch('sic_reports/getReservationReportHandler', vm.searchInput)
        .then(() => {
          vm.$swal.close();
        });
    }
  },
};
</script>

<style lang="scss" scoped>
  select {
    background-image: url(../../../assets/images/icon/arrow-dropdown-1.png);
    background-repeat: no-repeat;
    background-size: 1rem;
    background-position: center right 1.2rem;
  }
  .custom-select:focus {
    outline: 0;
    box-shadow: 0 0 0 0;
  }
</style>
